import { Component, OnInit } from '@angular/core';
import { IntegrationService } from '../../../../services/integration.service';
import { ClientService } from '../../../../services/client.service';
import { ActivatedRoute } from "@angular/router";
@Component({
  selector: 'app-add-pippedrive-integrations',
  templateUrl: './add-pippedrive-integrations.component.html',
  styleUrls: ['./add-pippedrive-integrations.component.scss']
})
export class AddPippedriveIntegrationsComponent implements OnInit {
 token:any;
 nameAccount:any;
 data:any;
 id=null
  constructor(public route:ActivatedRoute, public clientService: ClientService, public integrationService: IntegrationService) { }

  ngOnInit() {
    this.id = this.route.snapshot.params['id'];
  }
  checkoutToken(){
    console.log(this.token)
     const  body={
          token:this.token
     }
     this.integrationService.checkoutToken(body)
     .subscribe((data:any) => {
      this.data = data;
      console.log("tokenizado")
      console.log(this.data)
      if(this.data.message=="user not found"){
        console.log("ingrese un token valido")
      }else{
        console.log("else")
       
        this.conectar();
      }
    });
   
  }
 conectar(){
  console.log("id"+this.id)
  this.nameAccount=this.data.data.company_name;
  console.log(this.nameAccount)
  const body={
    pippedriveToken:this.token,
    nameAccountPippedrive:this.nameAccount

  };
  this.clientService.update(body,this.id)
  .subscribe((data:any) => {
    console.log(data)
  });
   }
}



// WEBPACK FOOTER //
// ./src/app/components/integrations/pippedrive-integrations/add-pippedrive-integrations/add-pippedrive-integrations.component.ts